module.exports = __webpack_public_path__ + "img/mediate.b787b928.png";